export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8215.158acf51.jpg";